import { withCompController } from '@wix/editor-elements-integrations';
import type {
  TextEffectsSharedMapperProps,
  TextEffectsSharedStateValues,
  TextEffectsSharedControllerProps,
} from '../TextEffectsShared.types';

export default withCompController<
  TextEffectsSharedMapperProps,
  TextEffectsSharedControllerProps,
  never,
  TextEffectsSharedStateValues
>(({ stateValues, mapperProps }) => {
  return {
    ...mapperProps,
    initialReducedMotion: stateValues.reducedMotion,
    areTextEffectsPatternsEnabled:
      stateValues.experiments['specs.responsive-editor.TextEffectsPatterns'] ===
      true,
  };
});
